import './ccf-approved-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfApprovedIconProps extends SvgIconProps  {}
/**
 * This SVG is used to show approved icon 
 * @param props - CcfApprovedIconProps
 * @example - <CcfApprovedIcon />
 * @returns SVG of approved icon
 */
export function CcfApprovedIcon(props: CcfApprovedIconProps) {
  return (
    <SvgIcon {...props}>
    <g id="approval_approved">
    <path id="Path_25525" data-name="Path 25525" d="M-12290.838-1023.057l5.424,4.94,12.672-11.534" transform="translate(12293.789 1036.205)" fill="none" stroke="#23762d" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
  </g>
    </SvgIcon>
  );
}

export default CcfApprovedIcon;
